import { motion } from 'framer-motion';

const principles = [
  {
    title: 'Practical over theoretical',
    description: 'Solutions designed for real operational contexts, not abstract AI capabilities.',
  },
  {
    title: 'Built around your workflows',
    description: 'Every system starts from understanding how your team actually works.',
  },
  {
    title: 'Structured execution',
    description: 'Clear logic, defined routing, consistent handling — not black-box automation.',
  },
  {
    title: 'Start small, expand with confidence',
    description: 'Pilot implementations that prove value before broader rollout.',
  },
  {
    title: 'Visibility and control',
    description: 'Oversight built in from the start — monitoring, alerts, and human escalation.',
  },
  {
    title: 'Business-grade delivery',
    description: 'Professional implementation with proper handoff, documentation, and support.',
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 16 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4 },
  },
};

export const WhyPyrtex = () => {
  return (
    <section
      id="why"
      data-testid="why-pyrtex-section"
      className="bg-slate-950 py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-16">
          {/* Left Column - Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.5 }}
            className="lg:col-span-4"
          >
            <p className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold mb-4">
              Our Approach
            </p>
            <h2
              data-testid="why-heading"
              className="text-3xl md:text-4xl font-semibold tracking-tight text-white font-['Manrope'] leading-tight"
            >
              Why companies work with Pyrtex
            </h2>
          </motion.div>

          {/* Right Column - Principles */}
          <motion.div
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-100px' }}
            className="lg:col-span-8"
          >
            <div className="grid sm:grid-cols-2 gap-x-10 gap-y-10">
              {principles.map((principle, index) => (
                <motion.div
                  key={index}
                  variants={itemVariants}
                  data-testid={`why-principle-${index}`}
                >
                  <h3 className="text-base font-semibold text-white mb-2 font-['Manrope']">
                    {principle.title}
                  </h3>
                  <p className="text-sm text-slate-400 leading-relaxed">
                    {principle.description}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
